import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import { PageMode } from '../Basepage/parts/Definitions';
import ShopingCartItem from './Parts/ShopingCartItem';
import WebgainsBasketTag from './Parts/WebgainsBasketTag';

import './index.scss';

import {
  showShippingWarming,
  useWebgains,
  getTelNummberLink,
  getTelNummber,
} from './overrides';

interface ShoppingCartPageState extends BasePageState {}

interface ShoppingCartPageModel {
  items: ShoppingCartPageItemModel[];
  final_price: number;
  shipper_cost: number;
  messageStack: any[];
  FB_PIXEL: string[];
}

export default class ShoppingCartPage extends Basepage<
  ShoppingCartPageState,
  ShoppingCartPageModel
> {
  renderChild(): JSX.Element {
    let messageContainer = null;
    if (this.body.messageStack.length > 0) {
      messageContainer = (
        <div className="negmeldung">
          {this.body.messageStack.map((item, index) => {
            return (
              <div key={'meldung' + index}>
                <span
                  className="closebtn"
                  onClick={(e) => {
                    let tar: any = e.target;
                    tar.parentElement.style.display = 'none';
                  }}
                >
                  ×
                </span>
                <strong>Achtung:</strong>
                <div
                  style={{ display: 'inline' }}
                  dangerouslySetInnerHTML={{
                    __html: item.text,
                  }}
                />
              </div>
            );
          })}
        </div>
      );
    }
    let spaceSumme = null;
    //if (this.state.mode == ModeMobile) spaceSumme = <br />;
    //else
    spaceSumme = (
      <span style={{ paddingLeft: '10px' }} key="TextPadding"></span>
    );
    return (
      <div id="shoppingCart">
        {messageContainer}
        <div className="centerColumn" id="shoppingCartDefault">
          <div className="forward"></div>
          {/* 
          <h1>Ihr Warenkorb</h1>
          */}
          <form
            name="cart_quantity"
            action={'/index.php?main_page=shopping_cart&action=update_product'}
            method="post"
          >
            <input
              type="hidden"
              name="securityToken"
              defaultValue={this.state.apiData.securityToken}
            />
            <div id="cartInstructionsDisplay" className="content"></div>

            <table
              width="100%"
              cellSpacing="0"
              cellPadding="0"
              id="cartContentsDisplay"
            >
              <thead>
                <tr className="tableHeading">
                  <th scope="col" id="scQuantityHeading">
                    Anzahl
                  </th>
                  {this.state.mode != PageMode.Mobile ? (
                    <React.Fragment>
                      <th scope="col" id="scUpdateQuantity">
                        &nbsp;
                      </th>
                    </React.Fragment>
                  ) : null}
                  <th scope="col" id="scProductsHeading">
                    Artikel
                  </th>
                  {this.state.mode != PageMode.Mobile ? (
                    <React.Fragment>
                      <th scope="col" id="scUnitHeading">
                        Preis/Stk.
                      </th>
                    </React.Fragment>
                  ) : null}
                  <th scope="col" id="scTotalHeading">
                    Summe
                  </th>
                  {this.state.mode != PageMode.Mobile ? (
                    <React.Fragment>
                      <th scope="col" id="scRemoveHeading">
                        &nbsp;
                      </th>
                    </React.Fragment>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {/* <!-- Loop through all products /-->*/}
                {this.body.items != undefined && this.body.items.length > 0 ? (
                  this.body.items.map((item, index) => {
                    return (
                      <ShopingCartItem
                        index={index}
                        item={item}
                        mode={this.state.mode}
                        domainPrefix={this.state.renderingDomain}
                        key={'ShopingCartItem_' + index}
                      ></ShopingCartItem>
                    );
                  })
                ) : (
                  <React.Fragment>
                    <tr>
                      <td colSpan={this.state.mode != PageMode.Mobile ? 6 : 3}>
                        Ihr Warenkorb ist leer.
                      </td>
                    </tr>
                  </React.Fragment>
                )}
                {/* <!-- Finished loop through all products /--> */}
              </tbody>
            </table>
          </form>
          <div id="cartSubTotal" className="warenkorb">
            <form
              action="./index.php?main_page=page&amp;id=5&amp;checkout=klarna"
              method="POST"
            >
              <div id="gutscheinfeld">
                {/*  <!--<img src="/includes/templates/stirling_grand/images/kreuz.png" title="Gutschein entfernen" alt="Gutschein entfernen"> --> */}
                <input
                  type="text"
                  id="dc_redeem_code"
                  name="dc_redeem_code"
                  defaultValue="Gutscheincode"
                  onFocusCapture={(e) => {
                    if (e.target.value == 'Gutscheincode') {
                      e.target.value = '';
                    }
                  }}
                  onBlur={(e) => {
                    if (e.target.value == '') {
                      e.target.value = 'Gutscheincode';
                    }
                  }}
                  //onFocus="emptyfield();"
                  //onblur="restoredefault();"
                />
                &nbsp;
                <input
                  className="cssButton submit_button button"
                  onMouseOver={(e) => {
                    let target: any = e.target;
                    target.className = 'cssButtonHover Hover';
                  }}
                  onMouseOut={(e) => {
                    let target: any = e.target;
                    target.className = 'cssButton submit_button button';
                  }}
                  type="submit"
                  value="Code einlösen"
                />
              </div>
              <div id="bezahlen">
                <div className="cart_summe">
                  <span style={{ color: 'black' }} className="cart_summe_Text">
                    Zwischensumme (inkl. MwSt.):
                  </span>
                  {spaceSumme}
                  <span style={{ fontSize: '23.8px', whiteSpace: 'nowrap' }}>
                    {this.body.final_price.toFixed(2).replace('.', ',')} €
                  </span>
                </div>
                {this.body.shipper_cost > 0 ? (
                  <span className="cart_inhalt">
                    <React.Fragment>
                      zuzüglich {this.body.shipper_cost} € Versandkosten
                    </React.Fragment>
                  </span>
                ) : (
                  <span
                    className="cart_inhalt"
                    style={{
                      color: '#39B54A',
                      fontWeight: 'bold',
                      fontSize: '16px',
                    }}
                  >
                    <React.Fragment>
                      Wir liefern versandkostenfrei.
                    </React.Fragment>
                  </span>
                )}
              </div>
            </form>
            <div className="warenkorb-kasse-AGB">
              Mit dem Klick auf den Button: "zur Kasse gehen" oder "PayPal
              Checkout" bestätigen und akzeptieren Sie unsere{' '}
              <a
                href={'/index.php?main_page=conditions'}
                target="_blank"
                className="agbLink"
              >
                Allgemeinen Geschäftsbedingungen
              </a>{' '}
              und unsere{' '}
              <a
                href={'/index.php?main_page=widerrufsrecht'}
                target="_blank"
                className="agbLink"
              >
                Widerrufsbelehrung
              </a>
              .
            </div>
            <div className="warenkorb-kasse">
              <a
                href={'/index.php?main_page=page&id=5&checkout=klarna_v3'}
                rel="nofollow"
              >
                <input
                  className="button_in_checkout"
                  type="submit"
                  value="zur Kasse gehen"
                />
              </a>
              <a
                href={'/index.php?main_page=page&id=5&checkout=paypal_v2'}
                rel="nofollow"
              >
                <input
                  className="button_in_paypal"
                  type="submit"
                  value="Checkout"
                />
              </a>
            </div>
          </div>{' '}
          {/* <!-- cartSubTotal ENDE --> */}
          <br className="clearBoth" />
          {useWebgains() ? (
            <WebgainsBasketTag items={this.body.items}></WebgainsBasketTag>
          ) : null}
          {showShippingWarming() ? (
            <div id="achtung">
              <span style={{ color: '#ff0000' }}>⚠</span> Bitte beachten Sie:
              wenn Sie eine Lieferung an eine Adresse außerhalb von Deutschland
              wünschen, melden Sie sich bitte bei uns.
              <br />
              Gerne über unser{' '}
              <a href={'/index.php?main_page=contact_us'}>
                <u>Kontaktformular</u>
              </a>{' '}
              oder per Telefon:{' '}
              <a href={getTelNummberLink()}>☎ {getTelNummber()}</a>. Die
              Versandkosten finden Sie{' '}
              <u>
                <a
                  href={'/index.php?main_page=page&amp;id=126'}
                  title="Verssandkosten Ausland"
                >
                  hier
                </a>
              </u>
              .<br />
              <br />
              <span style={{ color: '#ff0000' }}>⚠</span> Please note: if you
              want delivery to an address outside of Germany, please contact us.
              <br />
              Gladly via our{' '}
              <a href={'/index.php?main_page=contact_us'}>
                <u>contact form</u>
              </a>{' '}
              or by phone: <a href={getTelNummberLink()}>☎ {getTelNummber()}</a>
              . Click{' '}
              <u>
                <a
                  href={'/index.php?main_page=page&amp;id=126'}
                  title="Verssandkosten Ausland"
                >
                  here
                </a>
              </u>{' '}
              to see the shipping cost.
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  initState(base: BasePageState): ShoppingCartPageState {
    let newState: ShoppingCartPageState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(): string {
    return this.state.apiBase + '/index.php?frame=api&main_page=shopping_cart';
  }
  childDidMount(): void {}
  childDidUnmount(): void {}

  initJSChild(): string {
    let initjs = '';
    if (this.body.FB_PIXEL != null) {
      initjs += `
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);
        //t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','//connect.facebook.net/en_US/fbevents.js');
        // Insert Your Facebook Pixel ID below. 
        fbq('init', '1300907099926580');
        
        fbq('init', '417368186590646'); //FB_MOLUNA_20211117_14

        fbq('track', 'PageView');
        `;

      for (let i = 0; i < this.body.FB_PIXEL.length; i++) {
        initjs += this.body.FB_PIXEL[i];
      }
    }
    return initjs;
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return null;
  }
  pageHeaderGetter(): string {
    return '<meta name="robots" content="noindex">';
  }
  pageTitleGetter(): string {
    return 'Warenkorb';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Warenkorb</span>;
  }
  getType(): string {
    return 'ShoppingCartPage';
  }
}
